<input #search [ngStyle]="{'height': height ? height + 'px' : 'auto', 'min-width': width ? width + 'px' : 'auto'}"
	   [placeholder]="inputAddress ? inputAddress : ''"
	   [value]="addAddress ? addAddress : ''"
	   class="form-control"
	   fullWidth nbInput
	   required shape="rectangle" status="primary" type="text"
	   (click)="width ? search.style.width=((search.value.length + 4) * 8) + 'px' : ''">
